interface BookIconProps {
	className?: string;
}

export function BookIcon({ className }: BookIconProps) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 17 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden="true"
		>
			<path
				d="M8.5 12.8381C7.35986 12.1799 6.06652 11.8333 4.75 11.8333C3.43347 11.8333 2.14014 12.1799 1 12.8381V2.00481C2.14014 1.34655 3.43347 1 4.75 1C6.06652 1 7.35986 1.34655 8.5 2.00481M8.5 12.8381C9.64014 12.1799 10.9335 11.8333 12.25 11.8333C13.5665 11.8333 14.8599 12.1799 16 12.8381V2.00481C14.8599 1.34655 13.5665 1 12.25 1C10.9335 1 9.64014 1.34655 8.5 2.00481M8.5 12.8381V2.00481"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
